// components
import AttributeInput from '../../../components/components/atoms/AttributeInput/AttributeInput';
import {Modal, Row, Column, Button, Table} from '@drivesally/sally-ui';

// date-fns
import {parseISO} from 'date-fns';
import {formatToTimeZone} from 'date-fns-timezone';

// lib
import getTimeZoneFromBranch from '../../../libs/getTimeZoneFromBranch';

// layout
import ModalLoader from '../../../layout/components/ModalLoader/ModalLoader';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Fragment} from 'react';

const columns = [
  {key: 'schedule_at', label: 'Schedule at'},
  {key: 'processing_amount', label: 'Processing amount'},
  {key: 'actions', label: ''},
];

const formatScheduleAt = (iso, timeZone) => {
  if (!iso) return '—';
  try {
    return timeZone
      ? formatToTimeZone(parseISO(iso), 'dddd h:mm A z', {timeZone})
      : formatToTimeZone(parseISO(iso), 'dddd h:mm A');
  } catch {
    return iso;
  }
};

const BranchVehicleDisableModal = ({
  branch,
  cancelEdit,
  changeEdit,
  changeNew,
  createSchedule,
  deleteSchedule,
  deletingId,
  editProcessing_amount,
  editSchedule_at,
  editingId,
  loading,
  newProcessing_amount,
  newSchedule_at,
  onClose,
  saveEdit,
  savingCreate,
  savingUpdateId,
  schedules,
  startEdit,
  visible,
}) => {
  const timeZone = getTimeZoneFromBranch({branch});
  const busy =
    !!savingCreate || !!savingUpdateId || deletingId !== null;

  return (
    <Modal
      title="Deactivation Schedules"
      subtitle={branch?.name ? branch.name : ''}
      visible={visible}
      onClose={onClose}
      size="large"
    >
      {(Content) => (
        <Fragment>
          <Content padding="none" noBorder>
            {loading ? (
              <ModalLoader />
            ) : (
              <Table columns={columns} noBorder noRadius smallNoResultsLabel>
                {(TableRow) =>
                  schedules.map((schedule) => {
                    const isEditing = editingId === schedule.id;
                    const rowBusy =
                      savingUpdateId === schedule.id ||
                      deletingId === schedule.id;
                    return (
                      <TableRow key={schedule.id}>
                        {(TableCol) => [
                          <TableCol key="schedule_at">
                            {isEditing ? (
                              <AttributeInput
                                value={editSchedule_at}
                                onChange={changeEdit}
                                disabled={rowBusy}
                                timeZone={timeZone}
                              >
                                {editSchedule_at.label.default}
                              </AttributeInput>
                            ) : (
                              formatScheduleAt(schedule.schedule_at, timeZone)
                            )}
                          </TableCol>,
                          <TableCol key="processing_amount">
                            {isEditing ? (
                              <AttributeInput
                                value={editProcessing_amount}
                                onChange={changeEdit}
                                disabled={rowBusy}
                              >
                                {editProcessing_amount.label.default}
                              </AttributeInput>
                            ) : (
                              schedule.processing_amount
                            )}
                          </TableCol>,
                          <TableCol key="actions" align="right">
                            {isEditing ? (
                              <Fragment>
                                <Button
                                  size="small"
                                  onClick={saveEdit}
                                  loading={savingUpdateId === schedule.id}
                                  disabled={
                                    deletingId !== null && deletingId !== schedule.id
                                  }
                                >
                                  Save
                                </Button>
                                <Button
                                  size="small"
                                  theme="grey"
                                  onClick={cancelEdit}
                                  disabled={rowBusy}
                                >
                                  Cancel
                                </Button>
                              </Fragment>
                            ) : (
                              <Fragment>
                                <Button
                                  size="small"
                                  theme="grey"
                                  icon="edit"
                                  onClick={() => startEdit(schedule)}
                                  disabled={busy || editingId !== null}
                                />
                                <Button
                                  size="small"
                                  theme="grey"
                                  icon="delete"
                                  onClick={() => deleteSchedule(schedule.id)}
                                  loading={deletingId === schedule.id}
                                  disabled={
                                    busy ||
                                    (editingId !== null && editingId !== schedule.id)
                                  }
                                />
                              </Fragment>
                            )}
                          </TableCol>,
                        ]}
                      </TableRow>
                    );
                  })
                }
              </Table>
            )}
          </Content>
          <Content>
            <Row margin>
              <Column size={2 / 5}>
                <AttributeInput
                  value={newSchedule_at}
                  onChange={changeNew}
                  disabled={busy || loading || editingId !== null}
                  timeZone={timeZone}
                >
                  {newSchedule_at.label.default}
                </AttributeInput>
              </Column>
              <Column size={2 / 5}>
                <AttributeInput
                  value={newProcessing_amount}
                  onChange={changeNew}
                  disabled={busy || loading || editingId !== null}
                >
                  {newProcessing_amount.label.default}
                </AttributeInput>
              </Column>
              <Column size={1 / 5}>
                <div style={{height: '100%', display: 'flex', alignItems: 'flex-end'}}>
                  <Button
                    onClick={createSchedule}
                    loading={savingCreate}
                    disabled={busy || loading || editingId !== null}
                  >
                    Add Schedule
                  </Button>
                </div>
              </Column>
            </Row>
          </Content>
        </Fragment>
      )}
    </Modal>
  );
};

BranchVehicleDisableModal.propTypes = {
  branch: PropTypes.object,
  cancelEdit: PropTypes.func,
  changeEdit: PropTypes.func,
  changeNew: PropTypes.func,
  createSchedule: PropTypes.func,
  deleteSchedule: PropTypes.func,
  deletingId: PropTypes.any,
  editProcessing_amount: PropTypes.object,
  editSchedule_at: PropTypes.object,
  editingId: PropTypes.any,
  loading: PropTypes.bool,
  newProcessing_amount: PropTypes.object,
  newSchedule_at: PropTypes.object,
  onClose: PropTypes.func,
  saveEdit: PropTypes.func,
  savingCreate: PropTypes.bool,
  savingUpdateId: PropTypes.any,
  schedules: PropTypes.array,
  startEdit: PropTypes.func,
  visible: PropTypes.bool,
};

export default BranchVehicleDisableModal;
